import { render, staticRenderFns } from "./ProductComponent.vue?vue&type=template&id=ebf2407e&scoped=true&"
import script from "./ProductComponent.vue?vue&type=script&lang=js&"
export * from "./ProductComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProductComponent.vue?vue&type=style&index=0&id=ebf2407e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf2407e",
  null
  
)

export default component.exports